import { render, staticRenderFns } from "./specialtydialog.vue?vue&type=template&id=33e575a4&scoped=true"
import script from "./specialtydialog.vue?vue&type=script&lang=js"
export * from "./specialtydialog.vue?vue&type=script&lang=js"
import style0 from "./specialtydialog.vue?vue&type=style&index=0&id=33e575a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e575a4",
  null
  
)

export default component.exports